import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import state from "./state";
import mutations from "./mutations";
import getters from "./getters";

// vuex Modules
import pbaseX from "./modules/pbase";
import pacntX from "./modules/pacnt";
import pbankX from "./modules/pbank";
import pmrpX from "./modules/pmrp";
import pmrpAlX from "./modules/pmrpAl";
import pmrpValvsX from "./modules/pmrpValvs";
import phamyarX from "./modules/phamyar";
import phamsazX from "./modules/phamsaz";
import psaleX from "./modules/psale"; 
import pwhrsX from "./modules/pwhrs";
import pscmsX from "./modules/pscms";
import pcrmX from "./modules/pcrm";
import pstoreX from "./modules/pstore";
import pmktX from "./modules/pmkt";
import pparakX from "./modules/pparak";
import ptaxX from "./modules/ptax";
import pordrX from "./modules/pordr";
import pslryX from "./modules/pslry";
import pfincX from "./modules/pfinc";
import pparsinaX from "./modules/pparsina";
import dropdownX from "./modules/dropdownX";
import reportX from "./modules/reportX";
import fileX from "./modules/fileX";

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    pbaseX,
    pacntX,
    pbankX,
    pmrpX,
    pmrpAlX,
    pmrpValvsX,
    phamyarX,
    phamsazX,
    psaleX,
    pwhrsX,
    pscmsX,
    pcrmX,
    pstoreX,
    pmktX,
    pparakX,
    ptaxX,
    pordrX,
    pslryX,
    pfincX,
    pparsinaX,
    dropdownX,
    reportX,
    fileX,
  },
});
